import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {ORIGIN, PUBLIC_PAGES} from './routes';
export default function PublicMetadata() {
  const {pathname} = useLocation();
  useEffect(() => {
    if (pathname.startsWith('/p/')) return;
    const page = PUBLIC_PAGES[pathname];
    const set = (selector, tag, attrs) => {
      let node=document.head.querySelector(selector);
      if (!node) {node=document.createElement(tag);document.head.appendChild(node);}
      Object.entries(attrs).forEach(([k,v])=>node.setAttribute(k,v));
    };
    set('meta[name="robots"]','meta',{name:'robots',content:page?'index, follow':'noindex, follow'});
    if (page) {
      document.title=page.title;
      set('meta[name="description"]','meta',{name:'description',content:page.description});
      set('link[rel="canonical"]','link',{rel:'canonical',href:ORIGIN+pathname});
      Object.entries({'og:title':page.title,'og:description':page.description,'og:type':'website','og:url':ORIGIN+pathname,'og:site_name':'INSIGHT','og:locale':'en_IN'}).forEach(([property,content])=>set(`meta[property="${property}"]`,'meta',{property,content}));
    } else {
      document.querySelectorAll('link[rel="canonical"],meta[property^="og:"]').forEach(node=>node.remove());
      if (pathname==='/login') document.title='Login | INSIGHT';
      if (pathname==='/register') document.title='Register | INSIGHT';
    }
  },[pathname]);
  return null;
}
